"use client"

import React from "react"
import { motion } from "framer-motion"
import { Card } from "./card"

interface AnimatedCardProps extends React.ComponentProps<typeof Card> {
  delay?: number
}

export function AnimatedCard({ children, delay = 0, ...props }: AnimatedCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
    >
      <Card {...props}>{children}</Card>
    </motion.div>
  )
}